import styles from './MainTop.module.css';
import fon from '../../assets/img/fon.jpg';

export const MainTop = () => {
  return (
    <div 
      className={styles.container}
      style={{ 
        backgroundImage: `url(${fon})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <h1 className={styles.logo}>Берег</h1>
      <div className={styles.titles}>
        <h1 className={styles.mainTitle}>МЕСТО ДЛЯ ОТДЫХА <br /> БЕРЕГ</h1>
        <h2 className={styles.subTitle}>САМАРА</h2>
      </div>
    </div>
  );
};